module.exports = __webpack_public_path__ + "img/weight-hanging.9fc8c1aa.svg";